import Stones from './Stones'

export default Stones
// eslint-disable-next-line import/export
export * from './Stones'
